export function toggleLanguage() {
    const $languages = $(".languages");
    const $current = $languages.find(".current");
    const $langDropdown = $languages.find("ul");
    const $langLink = $langDropdown.find("a");
    let expandMenu;
    let $body = $("body");

    $current.on("click", function (evt) {
        evt.preventDefault();
        expandMenu = $(".expand");

        if (expandMenu.hasClass("languages") && $(this).closest(".expand").length === 0) {
            expandMenu.removeClass("expand");
            expandMenu.find("ul").slideUp();
        }

        $(this).closest(".languages").toggleClass("expand");
        $(this).closest(".languages").find("ul").stop().slideToggle();

        setTimeout(function() {
            if (!$body.hasClass("white-header") && $(window).width() < 1200) {
                $(".mega-menu-wrap").removeClass("active");
            }
        }, 0);
    });

    $langLink.on("click", function () {
        $current.text($(this).text());
        closeDropdown();
    });

    $(document).on("click", function (evt) {
        if ( !$(evt.target).closest(".languages").length) {
            closeDropdown();
        }
    });

    function closeDropdown() {
        for (let i = 0; i < $languages.length; i++) {
            $($languages[i]).removeClass("expand");
            $($langDropdown[i]).slideUp();
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/toggle-language.js